import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from "@/layout/index.vue"

Vue.use(VueRouter);


// 个人中心路由
// profileConstantRoutes.js
export const profileConstantRoutes = [
  {
    path: "/",
    name: "Profile",
    meta: {
      showChild: true,
      navLeft: true,
      title: "个人中心",
      icon: "user",
      roles: ["admin", "user"] // 通用权限
    },
    children: [
      // 账号信息
      {
        path: "info",
        component: () => import("@/views/profile/info.vue"),
        name: "ProfileInfo",
        meta: {
          title: "账号信息",
          icon: "id-card",
          roles: ["admin", "user"],
          navLeft: true,
        },
      },
      // 登录设置
      {
        path: "login",
        component: () => import("@/views/profile/login.vue"),
        name: "ProfileLogin",
        meta: {
          title: "登录设置",
          icon: "lock",
          roles: ["admin", "user"],
          navLeft: true,
        },
      },
      // 我的收藏
      {
        path: "collect",
        component: () => import("@/views/profile/collect.vue"),
        name: "ProfileCollect",
        meta: {
          title: "我的收藏",
          icon: "star",
          roles: ["admin", "user"],
          navLeft: true,
        },
      },
      // 我的发布
      {
        path: "publish",
        name: "Publish",
        meta: {
          title: "我的发布",
          icon: "upload",
          roles: ["admin", "user"],
          navLeft: true,
        },
        children: [
          {
            path: "release",
            component: () => import("@/views/publish/release.vue"),
            name: "PublishRelease",
            meta: {
              title: "我要发布",
              roles: ["admin", "user"],
              navLeft: true,
            },
          },
          {
            path: "rent",
            component: () => import("@/views/publish/rent.vue"),
            name: "PublishRent",
            meta: {
              title: "我的求租",
              roles: ["admin", "user"],
              navLeft: true,
            },
          },
          {
            path: "lease",
            component: () => import("@/views/publish/lease.vue"),
            name: "PublishLease",
            meta: {
              title: "我的出租",
              roles: ["admin", "user"],
              navLeft: true,
            },
          }
        ]
      },
      // 帮助中心
      {
        path: "help",
        name: "Help",
        meta: {
          title: "帮助中心",
          icon: "question",
          roles: ["admin", "user"],
          showChild: true

        },
        children: [
          {
            path: "contact",
            component: () => import("@/views/help/contact.vue"),
            name: "HelpContact",
            meta: {
              title: "联系客服",
              roles: ["admin", "user"],
              showChild: true
            },
          },
          {
            path: "leave",
            component: () => import("@/views/help/leave.vue"),
            name: "HelpLeave",
            meta: {
              title: "在线留言",
              roles: ["admin", "user"],
              showChild: true
            },
          },
          {
            path: "mini",
            component: () => import("@/views/help/mini.vue"),
            name: "HelpMini",
            meta: {
              title: "进入小程序",
              roles: ["admin", "user"],
              showChild: true
            },
          }
        ]
      }
    ]
  }
];


// 公共路由
export const routes = [
  {
    path: '/redirect',
    component: Layout,

    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/register',
    component: () => import('@/views/register'),

  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),

  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),

  },
  {
    path: '',
    component: Layout,
    redirect: 'home',
    children: [
      {
        path: '/login',
        component: () => import('@/views/login.vue'),
        name: "Login",
        meta: { title: '登录页',hideInBreadcrumb: false }
      },
      {
        path: '/userAgreement',
        component: () => import('@/views/UserAgreement.vue'),
        name: "UserAgreement",
        meta: { title: '用户服务协议', hideInBreadcrumb: false}
      },
      {
        path: 'home',
        component: () => import('@/views/home.vue'),
        name: 'Home',
        meta: { title: '首页', showChild: true ,hideInBreadcrumb: false}
      },
      // {
      //   path: 'profile',
      //   component: () => import('@/views/profile.vue'),
      //   name: 'Profile',
      //   meta: { title: '个人中心', showChild: true },
      //   children: profileConstantRoutes // 直接取子路由数组
      // },
       // 账号信息
      {
        path: "info",
        component: () => import("@/views/profile/info.vue"),
        name: "ProfileInfo",
        meta: {
          title: "账号信息",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      // 经纪人认证
      {
        path: "certifiedManager",
        component: () => import("@/views/profile/certifiedManager.vue"),
        name: "ProfileCertifiedManager",
        meta: {
          title: "经纪人认证",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      // 登录设置
      {
        path: "login",
        component: () => import("@/views/profile/login.vue"),
        name: "ProfileLogin",
        meta: {
          title: "登录设置",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      // 我的收藏
      {
        path: "collect",
        component: () => import("@/views/profile/collect.vue"),
        name: "ProfileCollect",
        meta: {
          title: "我的收藏",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      {
        path: "release",
        component: () => import("@/views/publish/release.vue"),
        name: "PublishRelease",
        meta: {
          title: "我要发布",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      {
        path: "rent",
        component: () => import("@/views/publish/rent.vue"),
        name: "PublishRent",
        meta: {
          title: "我的求租",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      {
        path: "lease",
        component: () => import("@/views/publish/lease.vue"),
        name: "PublishLease",
        meta: {
          title: "我的出租",
          navLeft: true,
          showChild: true,
          requireAuth: true
        },
      },
      {
        path: "contact",
        component: () => import("@/views/help/contact.vue"),
        name: "HelpContact",
        meta: {
          title: "联系客服",
          showChild: true,
          navLeft: true,
        },
      },
      {
        path: "leave",
        component: () => import("@/views/help/leave.vue"),
        name: "HelpLeave",
        meta: {
          title: "在线留言",
          showChild: true,
          navLeft: true,
        },
      },
      {
        path: "mini",
        component: () => import("@/views/help/mini.vue"),
        name: "HelpMini",
        meta: {
          title: "进入小程序",
          showChild: true,
          navLeft: true,
        },
      },
      {
        path: "search",
        component: () => import("@/views/searchDetail.vue"),
        name: "Search",
        meta: {
          title: "搜索",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "videoCase",
        component: () => import("@/views/videoCase.vue"),
        name: "VideoCase",
        meta: {
          title: "成交视频案例",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "videoCaseDetail",
        component: () => import("@/views/videoCaseDetail.vue"),
        name: "VideoCaseDetail",
        meta: {
          title: "成交视频案例详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shopTransfer",
        component: () => import("@/views/shopTransfer.vue"),
        name: "ShopTransfer",
        meta: {
          title: "商铺转让",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shopTransferDetail",
        component: () => import("@/views/shopTransferDetail.vue"),
        name: "ShopTransferDetail",
        meta: {
          title: "商铺转让详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shoprental",
        component: () => import("@/views/shop/shoprental.vue"),
        name: "Shoprental",
        meta: {
          title: "商铺出租",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shoprentalDetail",
        component: () => import("@/views/shop/shoprentalDetail.vue"),
        name: "ShoprentalDetail",
        meta: {
          title: "商铺出租详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shopforRent",
        component: () => import("@/views/shop/shopforRent.vue"),
        name: "ShopforRent",
        meta: {
          title: "商铺求租",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "shopforRentDetail",
        component: () => import("@/views/shop/shopforRentDetail.vue"),
        name: "ShopforRentDetail",
        meta: {
          title: "商铺求租详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "completedCase",
        component: () => import("@/views/shop/completedCase.vue"),
        name: "CompletedCase",
        meta: {
          title: "成交案例",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "completedCaseDetail",
        component: () => import("@/views/shop/completedCaseDetail.vue"),
        name: "CompletedCaseDetail",
        meta: {
          title: "成交案例详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "businesscoper",
        component: () => import("@/views/shop/businesscoper.vue"),
        name: "Businesscoper",
        meta: {
          title: "招商合作",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "businesscoperDetail",
        component: () => import("@/views/shop/businesscoperDetail.vue"),
        name: "BusinesscoperDetail",
        meta: {
          title: "招商合作详情",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "latestrans",
        component: () => import("@/views/latestrans.vue"),
        name: "Latestrans",
        meta: {
          title: "最新成交",
          showChild: true,
          hideInBreadcrumb: true
          // navLeft: true, //会员中心
        },
      },
      {
        path: "informNotice",
        component: () => import("@/views/informNotice.vue"),
        name: "InformNotice",
        meta: {
          title: "通知公告",
          showChild: true,
          // navLeft: true, //会员中心
        },
      },
      {
        path: "informDetail",
        component: () => import("@/views/informDetail.vue"),
        name: "InformDetail",
        meta: {
          title: "通知公告详情",
          showChild: true,
          // navLeft: true, //会员中心
        },
      },
      {
        path: "corporateCulture",
        component: () => import("@/views/corporateCulture.vue"),
        name: "CorporateCulture",
        meta: {
          title: "企业文化",
          showChild: true,
          corporateCulture:true,//企业文化
          // navLeft: true, //会员中心
        },
      }

    ]
  },
]



// 静默处理路由导航错误（含重定向、重复导航等）
;['push', 'replace'].forEach(function (method) {
  var original = VueRouter.prototype[method]
  VueRouter.prototype[method] = function (location) {
    return original.call(this, location).catch(function () {})
  }
})


const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior: function () {
    return { x: 0, y: 0 }
  },
});
// 全局路由守卫
router.beforeEach(function (to, from, next) {
  console.log(to.meta.requireAuth,'111222')
  if (to.meta.requireAuth) {
    var token = localStorage.getItem('token')
    if (!token) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router;
